import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { setGroupedRulesErrors, setIsLoading, setRulesErrors } from '../store/rules.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { groupedByParentLabel, mapRuleErrors, runRulesValidation } from '../../../utilities/runRulesValidation.util'
import { RulesConstants } from '../store/rules.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { IRulesOptionsState } from '../../options/store/options.types'
import { getRulesOptionsSelector } from '../../options/selectors'
import { IDatasetDeterminationData } from '../../completeChart/store/completeChart.types'
import Logger from '../../../services/logger.service'

export function* runAllRules() {
  const rulesOptions: IRulesOptionsState = yield select(getRulesOptionsSelector)
  const { standardRules, xsdRules, nationalRules, stateRules, serviceRules } = rulesOptions
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

      // Figure out the unique datasets from the stateRules and save this to the PCR
      const dataSets: Set<string> = new Set(
        (stateRules ?? []).map((obj) => obj.sourceType).filter((sourceType): sourceType is string => !!sourceType)
      )

      const datasetDeterminationData: IDatasetDeterminationData = Array.from(dataSets, (dataSet) => ({ dataSet }))

      pcrDoc.completeChart = {
        ...pcrDoc.completeChart,
        datasetDeterminationSet: true,
        datasetDetermination: datasetDeterminationData,
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
      Logger.info(
        `datasetDeterminationData for PCR: ${pcrID} has been set to ${JSON.stringify(datasetDeterminationData)}`
      )

      const errors = runRulesValidation(
        [...standardRules, ...xsdRules, ...nationalRules, ...stateRules, ...serviceRules],
        pcrDoc
      )

      yield put(setGroupedRulesErrors(groupedByParentLabel(errors.rulesErrors)))
      yield put(setRulesErrors(mapRuleErrors(errors.rulesErrors)))
    } catch (e) {
      yield put(throwPcrException(`runAllRules() error: ${e}`))
    }
  }
  yield put(setIsLoading(false))
}

export function* runAllRulesSaga() {
  yield takeLatest([RulesConstants.RUN_ALL_RULES], performWithMutexHOG, runAllRules)
}
